<template>
	<div style="text-align: center;min-height: 400px;display: flex;align-items: center;justify-content: center;flex-direction:column;">
		<el-upload ref="upload" drag :show-file-list="false" :on-progress="onProgress" :on-change="onChange"
							 :on-success="uploadSuccess" :on-error="uploadError" :before-upload="beforeUpload" :action="getUploadUrl()" v-loading="uploading">
			<i class="el-icon-upload"></i>
			<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
			<div class="el-upload__tip" slot="tip" style="font-size: 13px;">
				注意:仅支持上传指定格式的Excel模板文件。
			</div>
		</el-upload>
		<el-row class="upload-result" v-if="uploadResult.name!=''">
			<el-col :span="20">
				<div class="upload-result-content">
					<div class="title">{{uploadResult.name}}</div>
				</div>
			</el-col>
			<el-col :span="4">
				<div class="upload-result-content">
					<el-progress :percentage="uploadResult.percent" type="circle" :width="50"></el-progress>
				</div>
			</el-col>
		</el-row>
		<el-row v-if="uploadResult.name!='' && uploadResult.url !='' ">
			<a :href="uploadResult.url">{{uploadResult.msg}}</a>
		</el-row>
		<el-link type="primary" icon="el-icon-download" style="margin-top: 50px;" href="https://cdn.meetingmeet.com/fundexcel/%E5%AE%A2%E6%88%B7%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx">点我下载Excel模板</el-link>
	</div>
</template>

<script>
	import config from "../../../config/global.js";

	var uploadUrl = config.host+"/backend/excel/uploadcustomer";

    export default {
        name: "upload-customer-product-panel",
			data:function () {
				return {
					uploadResult:{name:"",percent:0,url:"",msg:"",status:""},
					excelOptions:[],
					uploading:false,
					loading:false,
				}
			},
			methods:{
				getUploadUrl:function () {
					return uploadUrl;
				},
				beforeUpload:function (file) {
					this.uploading = true;
					return true;
				},
				onChange:function(file, fileList){
					this.uploadResult.name = file.name;
				},
				onProgress:function (event, file, fileList) {
					this.uploadResult.percent = event.percent;
				},
				uploadSuccess:function (response, file, fileList) {
					this.uploading = false;
					if(response.result == 1){
						var msg = "文件已上传，成功"+response.customerlistResultTotal+"条,失败"+response.customerlistErrorTotal+"条";
						if(response.customerlistErrorTotal>0){
							var fileObject = fileList[0];
							this.uploadResult.msg = "上传结果:共"+response.customerlistResultTotal+"条记录,失败"+response.customerlistErrorTotal+"条.点击下载失败记录";
							this.uploadResult.url = response.errorexcelurl;
						}else{
							var fileObject = fileList[0];
							this.uploadResult.msg = "上传结果:成功.共"+response.customerlistResultTotal+"条记录";
							this.uploadResult.url = "";
						}
						this.$refs.upload.clearFiles();
						this.$alert(msg, '提示', {
							confirmButtonText: '确定',
						})
						this.$emit("uploadsuccess");
					}else{
						this.$alert("上传失败,请重试", '提示', {
							confirmButtonText: '确定',
						})
					}
				},
				uploadError:function () {
					this.uploading = false;
					this.$message.error('上传失败,请重试');
				}
			}
    }
</script>

<style scoped>
	.el-dialog__header{
		padding: 5px 10px;
	}

	.upload-result{
		background-color: #fdefab;
		border-radius: 5px;
		line-height: 20px;
		min-height: 60px;
		margin: 10px;
		width: 80%;
	}

	.upload-result .title{
		font-size: 14px;
		color: #606266;
		margin: 5px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 100%;
	}

	.upload-result a{
		font-size: 12px;
		color: #F23946;
		margin: 5px;
	}

	.upload-result-content{
		height: 60px;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}
</style>



// WEBPACK FOOTER //
// src/layouts/customer/UploadCustomerProductPanel.vue